export const SPACER_DEFAULTS = {
  margin: '0px 0px 0px 0px',
};
